package com.heelion.farmafreelance.agent

/**
 * Province italiane: nome -> sigla. Nel database le province sono salvate come sigla ("RM"),
 * mentre a voce si dice il nome ("in provincia di Roma"): serve per le ricerche di Farmy.
 * Tabella fissa perché deve funzionare anche sul web, dove il json dei comuni non viene caricato.
 */
object Province {
    private val SIGLE = mapOf(
        "agrigento" to "AG", "alessandria" to "AL", "ancona" to "AN", "aosta" to "AO", "arezzo" to "AR",
        "ascoli piceno" to "AP", "asti" to "AT", "avellino" to "AV", "bari" to "BA", "barletta andria trani" to "BT",
        "belluno" to "BL", "benevento" to "BN", "bergamo" to "BG", "biella" to "BI", "bologna" to "BO",
        "bolzano" to "BZ", "brescia" to "BS", "brindisi" to "BR", "cagliari" to "CA", "caltanissetta" to "CL",
        "campobasso" to "CB", "caserta" to "CE", "catania" to "CT", "catanzaro" to "CZ", "chieti" to "CH",
        "como" to "CO", "cosenza" to "CS", "cremona" to "CR", "crotone" to "KR", "cuneo" to "CN", "enna" to "EN",
        "fermo" to "FM", "ferrara" to "FE", "firenze" to "FI", "foggia" to "FG", "forli cesena" to "FC",
        "frosinone" to "FR", "genova" to "GE", "gorizia" to "GO", "grosseto" to "GR", "imperia" to "IM",
        "isernia" to "IS", "la spezia" to "SP", "l aquila" to "AQ", "latina" to "LT", "lecce" to "LE",
        "lecco" to "LC", "livorno" to "LI", "lodi" to "LO", "lucca" to "LU", "macerata" to "MC", "mantova" to "MN",
        "massa carrara" to "MS", "matera" to "MT", "messina" to "ME", "milano" to "MI", "modena" to "MO",
        "monza" to "MB", "monza e brianza" to "MB", "napoli" to "NA", "novara" to "NO", "nuoro" to "NU",
        "oristano" to "OR", "padova" to "PD", "palermo" to "PA", "parma" to "PR", "pavia" to "PV", "perugia" to "PG",
        "pesaro urbino" to "PU", "pescara" to "PE", "piacenza" to "PC", "pisa" to "PI", "pistoia" to "PT",
        "pordenone" to "PN", "potenza" to "PZ", "prato" to "PO", "ragusa" to "RG", "ravenna" to "RA",
        "reggio calabria" to "RC", "reggio emilia" to "RE", "rieti" to "RI", "rimini" to "RN", "roma" to "RM",
        "rovigo" to "RO", "salerno" to "SA", "sassari" to "SS", "savona" to "SV", "siena" to "SI", "siracusa" to "SR",
        "sondrio" to "SO", "sud sardegna" to "SU", "taranto" to "TA", "teramo" to "TE", "terni" to "TR",
        "torino" to "TO", "trapani" to "TP", "trento" to "TN", "treviso" to "TV", "trieste" to "TS", "udine" to "UD",
        "varese" to "VA", "venezia" to "VE", "verbano cusio ossola" to "VB", "vercelli" to "VC", "verona" to "VR",
        "vibo valentia" to "VV", "vicenza" to "VI", "viterbo" to "VT"
    )

    /** "Roma"/"roma"/"RM" -> "RM"; null se non è una provincia. */
    fun sigla(nomeOSigla: String): String? {
        val n = IntentClassifier.normalizza(nomeOSigla)
        return SIGLE[n] ?: n.uppercase().takeIf { it.length == 2 && it in SIGLE.values }
    }
}
